// src/hooks/useMasterOptions.js
import { useEffect, useMemo, useState } from "react";
import { fetchMasters } from "../api/masterdata";

export function useMasterOptions() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [options, setOptions] = useState({
    productOptions: [],
    modelOptions: [],
    colorOptions: [],
    capacityOptions: [],
    accessoriesOptions: [],
  });

  const requests = useMemo(
    () => [
      { key: "productOptions", path: "/categories", field: "name" }, // label=name, value=id (default)
      { key: "modelOptions", path: "/models", field: "name" },
      { key: "colorOptions", path: "/colors", field: "name" },
      { key: "capacityOptions", path: "/capacities", field: "size" },
      { key: "accessoriesOptions", path: "/accessories", field: "name" },
    ],
    []
  );

  useEffect(() => {
    let alive = true;

    (async () => {
      setLoading(true);
      setError("");
      try {
        const data = await fetchMasters(requests);
        if (!alive) return;
        setOptions((prev) => ({ ...prev, ...data }));
      } catch (e) {
        console.error("load master options error:", e);
        if (!alive) return;
        setError("โหลดข้อมูลตัวเลือกไม่สำเร็จ");
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, [requests]);

  return { ...options, loading, error };
}